import { render, staticRenderFns } from "./curriculumNamesixth.vue?vue&type=template&id=b52693be&scoped=true"
import script from "./curriculumNamesixth.vue?vue&type=script&lang=js"
export * from "./curriculumNamesixth.vue?vue&type=script&lang=js"
import style0 from "./curriculumNamesixth.vue?vue&type=style&index=0&id=b52693be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52693be",
  null
  
)

export default component.exports